module.exports = __webpack_public_path__ + "img/sfojp-currency-guide-1.83f6b8b7.png";